// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__dtNk8","ctaButton":"Cta_ctaButton__MXFkw","primary":"Cta_primary__INcvN","outlined":"Cta_outlined__fIDGN","secondary":"Cta_secondary__rJzCD"};